import {BaseModel} from "../base.model";

export interface RelationTree extends BaseModel {
    
}

export const defaultRelationTree:  Readonly<RelationTree> = {};